export function isElementInDomAndHasText(
  selector: string,
  text: string
): boolean {
  const element: HTMLElement | null = document.querySelector(selector)
  return Boolean(element && element.innerText === text)
}
